module.exports = __webpack_public_path__ + "static/img/30.a22e90f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/30.jpg
// module id = Bc/d
// module chunks = 3